/**
 * Sentry init for the React frontend. No-ops if REACT_APP_SENTRY_DSN is not set.
 * Loaded once from index.js before App mounts.
 */
let initialized = false;

export async function initSentry() {
    if (initialized) return;
    const dsn = process.env.REACT_APP_SENTRY_DSN;
    if (!dsn) {
        return;
    }
    try {
        const Sentry = await import("@sentry/react");
        Sentry.init({
            dsn,
            environment: process.env.REACT_APP_ENV || "production",
            tracesSampleRate: 0.1,
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 0.1,
            // Avoid capturing report contents in breadcrumbs/PII
            sendDefaultPii: false,
            beforeSend(event) {
                // Strip any URL query strings that might include sensitive ids
                if (event.request?.url) {
                    try {
                        const u = new URL(event.request.url);
                        u.search = "";
                        event.request.url = u.toString();
                    } catch { /* non-critical */ }
                }
                return event;
            },
        });
        initialized = true;
    } catch (e) {
        // intentionally quiet
    }
}

export async function identifyUser(user) {
    if (!initialized || !user) return;
    try {
        const Sentry = await import("@sentry/react");
        Sentry.setUser({ id: user.user_id, email: undefined });
    } catch { /* non-critical */ }
}
